@if (giftCards.length) {
  <p-table [value]="giftCards" [loading]="isLoading" tableStyleClass="gift-card-table">
    <!-- header -->
    <ng-template #header>
      <tr>
        <th>{{ 'GIFT_CARD.code' | translate }}</th>
        <th>{{ 'GIFT_CARD.balance' | translate }}</th>
        <th>{{ 'GIFT_CARD.status' | translate }}</th>
      </tr>
    </ng-template>

    <!-- rows -->
    <ng-template #body let-card>
      <tr>
        <td>{{ card.code }}</td>
        <td>{{ card.balance | price | usdPipe }}</td>
        <td>{{ card.status }}</td>
      </tr>
    </ng-template>
  </p-table>
} @else {
  <app-empty-page [message]="'ORDER.noGiftCards' | translate" />
}
